import React, { useState } from "react";
import {
  Rating,
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  Typography,
} from "@mui/material";
import arrowcurve from "../../../src/assests/images/arrow-down-curve.svg";

interface StarRatingProps {
    initialStars: number; // Initial star rating
    maxStarsOptions: number[]; // Array of options for the dropdown
  }

const StarRating : React.FC<StarRatingProps> = ({ initialStars, maxStarsOptions }) => {
  const [stars, setStars] = useState(initialStars); // Current star value
  const [maxStars, setMaxStars] = useState(5); // UnRated-stars as default (5)

  const handleChange = (event: SelectChangeEvent<number>) => {
    const selectedValue = Number(event.target.value); // Parse the selected value
    setMaxStars(selectedValue); // Update the maximum stars
    setStars(Math.min(stars, selectedValue)); // Adjust current stars if it exceeds the new maximum
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "end",WebkitJustifyContent:"space-between",marginLeft:"50px",}}>
      <Box>
        <Rating
          sx={{ fontSize: "29px" }}
          name="customized-dynamic"
          value={stars}
          max={maxStars}
          onChange={(event, newValue) => setStars(newValue || 0)}
        />
        <Box
          className="ratingnumber"
          sx={{ display: "flex", gap: "20px", marginLeft: "8px" }}
         >
          {Array.from({ length: maxStars }, (_, index) => (
            <Typography
              sx={{ fontSize: "16px", fontWeight: "500", color: "#494A4B" }}
              key={index}
              variant="caption"
              color="text.secondary"
            >
              {index + 1}
            </Typography>
          ))}
        </Box>
      </Box>

      {/* Select Dropdown */}
      <Select
        value={maxStars}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Select number of stars" }}
        sx={{
          borderRadius: "6px",
          borderColor: "red",
          fontSize: "13px",
          fontWeight: "500",
          color: "#282829",
          ".MuiSvgIcon-root path": { display: "none" },
          ".MuiSvgIcon-root": {
            backgroundImage: `url(${arrowcurve})`,
            width: "24px",
            height: "24px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          },
          ".MuiSelect-select": {
            color: "#000",
            fontSize: "16px",
            fontWeight: "500",
            padding: "16px 43px 16px 10px !important",
            lineHeight: "24px",
          },
        }}
      >
        {maxStarsOptions.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default StarRating;


